// @react
import React from 'react'
// @typings
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @components
import BioForm from 'modules/profile/components/Bio/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 * 5.0.1.2 Profile - Personal Information - Bio
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3123%3A16072
 *
 *
 * endpoint: user/profile
 * response: UserProfileDTO
 *
 * firstName
 * bio
 * gender
 * profileImageUrl
 * website
 * specialNeeds
 *
 */

type PropsType = Record<string, unknown>

const Bio = ({}: PropsType, ref: React.Ref<HTMLDivElement>) => {
  /****************************************
   *  GQL HOOKS
   ****************************************/

  const { loading: isLoading, error: isError, data, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, {
    fetchPolicy: 'cache-first',
    // notifyOnNetworkStatusChange: true, // @todo a bit crude with refetch, should really modify cache directly
  })

  /****************************************
   *  RENDER
   ****************************************/

  if (isError || (!data && !isLoading)) {
    return <QueryError />
  }

  return (
    <div ref={ref}>
      <BioForm data={data} isLoading={isLoading} refetch={refetch} />
    </div>
  )
}

export default React.forwardRef<HTMLDivElement>(Bio)
